// extracted by mini-css-extract-plugin
export var borderRadius = "_g8-4";
export var large = "_g8-3";
export var logoContainer = "_g8-0";
export var nameLogo = "_g8-2";
export var small = "_g8-1";